import React from "react";
import styled from "styled-components/macro";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Trans } from "react-i18next";
import { VideoTutorialSteps } from "./video/VideoTutorialSteps";
import { useEffect, useState } from "react";
import { useViewerQuery } from "queries/viewerQuery";
import { VIDEO_TUTORIAL } from "root/tutorial/steps/LongTouch";
import { EVENT, dispatchEvent } from "tools/events";
import { TUTORIALDONE } from "root/tutorial/steps/Verdict";

const Img = styled.img`
  width: 100%;
  padding: 10px 0;
`;
const SDialogActions = styled(DialogActions)`
  justify-content: center;
  width: 100%;
  padding: 10px 15px 20px;
`;
const SButton = styled(Button)`
  width: 100%;
`;
const SDialogTitle = styled(DialogTitle)`
  text-align: center;
  font-weight: bold;
`;

const InlineHint = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 20px);
  max-width: ${({ theme }) => theme.duo.maxWidth.normal};
  z-index: 999;
  background: ${({ theme }) => theme.duo.color.white};
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  font-size: 16px;
  color: ${({ theme }) => theme.duo.color.text};
`;

const ContentTutorialDialog: React.FC = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [inlineHintVisible, setInlineHintVisible] = useState(false);
  const { hintWasSeen } = useViewerQuery();

  useEffect(() => {
    if (!hintWasSeen(VIDEO_TUTORIAL) && hintWasSeen(TUTORIALDONE)) {
      setDialogOpen(true);
      dispatchEvent(EVENT.playVideo, false);
    }
  }, [hintWasSeen]);

  const handleClose = () => {
    setDialogOpen(false);
    setInlineHintVisible(true);
    dispatchEvent(EVENT.playVideo, true);
  };

  return (
    <>
      <Dialog open={dialogOpen} onClose={handleClose}>
        <SDialogTitle>
          <Trans>How to turn any video into learning cards</Trans>
        </SDialogTitle>
        <DialogContent>
          <Img src="https://cdn.duocards.com/img/video-subs.png" />
          <VideoTutorialSteps />
        </DialogContent>
        <SDialogActions>
          <SButton variant="contained" color="primary" onClick={handleClose}>
            <Trans>Got it</Trans>
          </SButton>
        </SDialogActions>
      </Dialog>

      {inlineHintVisible && (
        <InlineHint>
          <VideoTutorialSteps />
        </InlineHint>
      )}
    </>
  );
};

export default ContentTutorialDialog;
